export const columnsSearch = [
    {
        title: 'Дата постановки (последней постановки на учет по НДС)',
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (item) => (item ? item : '-'),
    },
    {
        title: 'Дата снятия (последнего снятия) с учета НДС',
        dataIndex: 'endDate',
        key: 'endDate',
        render: (item) => (item ? item : '-'),
    },
    {
        title: 'Причина снятия (последнего снятия) с учета по НДС',
        dataIndex: 'reason',
        key: 'reason',
        render: (item) => (item ? item : '-'),
    },
];

export const columnsCheck = [
    {
        title: 'Дата постановки (последней постановки на учет по НДС)',
        dataIndex: 'beginDate',
        key: 'beginDate',
        width: '150px',
        render: (item) => (item ? item : '-'),
    },
    {
        title: 'Дата снятия (последнего снятия) с учета НДС',
        dataIndex: 'endDate',
        key: 'endDate',
        width: '200px',
        render: (item) => (item ? item : '-'),
    },
    {
        title: 'Причина снятия (последнего снятия) с учета по НДС',
        dataIndex: 'reason',
        key: 'reason',
        width: '150px',
        render: (item) => (item ? item : '-'),
    },
    {
        title: 'Номер свидетельства',
        dataIndex: ['certificateInfo', 'number'],
        key: 'certificateInfo.number',
        render: (item) => (item ? item : '-'),
    },
    {
        title: 'Серия свидетельства',
        dataIndex: ['certificateInfo', 'series'],
        key: 'certificateInfo.series',
        render: (item) => (item ? item : '-'),
    },
    {
        title: 'Дата выдачи свидетельства',
        dataIndex: ['certificateInfo', 'beginDate'],
        key: 'certificateInfo.beginDate',
        render: (item) => (item ? item : '-'),
    },
    {
        title: 'Дата прекращения действия свидетельства',
        dataIndex: ['certificateInfo', 'endDate'],
        key: 'certificateInfo.endDate',
        render: (item) => (item ? item : '-'),
    },
    {
        title: 'Дата регистрации',
        dataIndex: ['certificateInfo', 'beginDate'],
        key: 'certificateInfo.beginDate',
        render: (item) => (item ? item : '-'),
    },
    {
        title: 'Статус',
        dataIndex: ['certificateInfo', 'status'],
        key: 'certificateInfo.status',
        render: (item) => (item == 'ACTUAL' ? 'Действительный' : 'Не действительный'),
        width: '150px',
    },
    {
        title: 'Причина прекращения действия свидетельства',
        dataIndex: ['certificateInfo', 'reason'],
        key: 'certificateInfo.reason',
        render: (item) => (item ? item : '-'),
    },
];